export const buildProvenance = { "commitHash": "ec692ff458be417855eee47781656fdcbe4c1a11", "branchName": "refs/heads/release/2024.2", "buildDate": "2024-08-21T01:39:37.440Z", "version": "2024.2.9409" };
